module.exports = __webpack_public_path__ + "img/verified-shield.1cc3443f.svg";